import { useEffect } from "react";
import DashboardGauge from "../components/DashboardGauge";
import { useGetPermitExpiredAvgDurationMetric } from "../operations/queries/getPermitAvgDurationMetrics";
import { useAppContext } from "../hooks/useAppContext";
import { PermitMetricScopeInput } from "../operations/queries/getPermitsCountByStatesMetric";

interface Props {
  scope?: PermitMetricScopeInput;
}

const PermitExpiredAvgDurationContainer = (props: Props) => {
  const { currentOrganization, currentPermitRegister } = useAppContext();

  const { getPermitExpiredAvgDurationMetric, data } = useGetPermitExpiredAvgDurationMetric();

  useEffect(() => {
    if (currentOrganization) {
      const activeScope: PermitMetricScopeInput = props.scope || {
        organizationId: currentOrganization.id,
        registerIds: currentPermitRegister?.id ? [currentPermitRegister.id] : null,
      };

      getPermitExpiredAvgDurationMetric({
        variables: { query: { scope: activeScope } },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrganization, currentPermitRegister, props.scope]);

  if (!data) return null;

  return (
    <DashboardGauge
      header="Review Efficiency"
      description="Average time in hours to mark an expired permit as complete"
      value={data.permitExpiredAvgDurationMetric.value > 0 ? data.permitExpiredAvgDurationMetric.value : null}
      maxValue={72}
    ></DashboardGauge>
  );
};

export default PermitExpiredAvgDurationContainer;
